import { render, staticRenderFns } from "./RealInformation.vue?vue&type=template&id=32c5068a"
import script from "./RealInformation.vue?vue&type=script&lang=js"
export * from "./RealInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports